import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=3fbc7f2a&"
import script from "./operate.vue?vue&type=script&lang=js&"
export * from "./operate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports